<template>
  <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
     <div class='goods-grid'>
      <dx-data-grid ref='refRawMaterialGrid'
        :data-source='rawMaterialInfoList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        :auto-navigate-to-focused-row="false"
        key-expr="품번"
        @cell-prepared='onCellPrepared'
        @toolbar-preparing='onToolbarPreparing'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          :file-name="stockTitle"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxColumnFixing :enabled="true"/>
        <DxColumn v-if="$store.getters.getGroupName !== null"
          :allowEditing='false'
          :caption="$store.getters.getGroupName"
          data-field="차종"
          sort-order='asc'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품번"
          data-field="품번"
          sort-order='asc'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품명"
          data-field="품명"
          :visible='true'
        >
        </DxColumn>

        <DxColumn
          :allowEditing='false'
          caption="구매처"
          data-field="거래처코드"
          :visible='true'
        >
          <DxLookup
            :data-source="companyInfoLookup"
            display-expr="거래처명"
            value-expr="거래처코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="자재유형"
          data-field="자재유형"
          :visible='true'
        >
          <DxLookup
            :data-source="meterialTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="단위"
          data-field="단위"
          :visible='true'
        >
          <DxLookup
            :data-source="unitLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          caption="협력사"
          alignment='center'
        >
          <DxColumn
            caption="산출재고"
            :calculate-cell-value="temp"
          />

          <DxColumn
            caption="현재고"
            :calculate-cell-value="calcTotalOutsourceStcokAmount"
          />
        </DxColumn>
        <DxColumn
          caption="오토다임"
          alignment='center'
        >
          <DxColumn
            caption="이월재공"
            data-field="이월재공"
          />
          <DxColumn
            caption="입고"
            data-field="입고수량"
          />
          <DxColumn
            caption="사용량"
            data-field="소요량"
          />
          <DxColumn
            caption="영업출하수량"
            data-field="출고수량"
          />
          <DxColumn
            caption="현재고"
            :calculate-cell-value="calcTotalStcokAmount"
          />
        </DxColumn>
        <!-- <DxColumn
          caption="재고현황"
          alignment='center'
        >
          <DxColumn
            :allowEditing='false'
            caption="창고 현재고"
            data-field="창고재고"
            :visible='true'
            format='#,##0'
            dataType="number"
          />
          <DxColumn
            :allowEditing='false'
            caption="재공 현재고"
            data-field="현재공"
            :visible='true'
            format='#,##0'
            dataType="number"
          />
          <DxColumn
            :allowEditing='false'
            caption="합계"
            :calculate-cell-value="calculateStcokAmount"
            :visible='true'
            format='#,##0'
            dataType="number"
          />
        </DxColumn> -->
        <!-- <DxColumn
          :allowEditing='false'
          caption="생산실적"
          data-field="상위품실적"
          :visible='false'
          format='#,##0'
          dataType="number"
        />
        <DxColumn
          :allowEditing='false'
          caption="금월생산수량"
          data-field="소요량"
          :visible='true'
          format='#,##0'
          dataType="number"
        />
        <DxColumn
          :allowEditing='false'
          caption="금월 실사재공"
          data-field="보정재공"
          :visible='true'
          format='#,##0'
          dataType="number"
        />
        <DxColumn
          :allowEditing='false'
          caption="창고이월재고"
          data-field="이월창고재고"
          :visible='true'
          format='#,##0'
          dataType="number"
        />
        <DxColumn
          :allowEditing='false'
          caption="창고재고보정"
          data-field="창고재고보정"
          :visible='false'
          format='#,##0'
          dataType="number"
        />
        <DxColumn
          :allowEditing='false'
          caption="이월재공"
          data-field="이월재공"
          :visible='true'
          format='#,##0'
          dataType="number"
        />
        <DxColumn
          :allowEditing='false'
          caption="재공보정"
          data-field="재공재고보정"
          :visible='false'
          format='#,##0'
          dataType="number"
        />
        <DxColumn
          :allowEditing='false'
          caption="금월입고"
          data-field="입고수량"
          :visible='true'
          format='#,##0'
          dataType="number"
        />
        <DxColumn
          :allowEditing='false'
          caption="반품/폐기"
          data-field="반품수량"
          :visible='true'
          format='#,##0'
          dataType="number"
        />
        <DxColumn
          :allowEditing='false'
          caption="금월납품"
          data-field="출고수량"
          :visible='true'
          format='#,##0'
        /> -->
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            column="품번"
            display-format="{0} (건)"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
    </div>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->

</template>

<script>
import Loading from 'vue-loading-overlay'
import AppLib from '../../../share/AppLib'
import ConstDef from '../../../share/ConstDef'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel, DxLookup } from 'devextreme-vue/data-grid'

export default {
  name: 'CurrentPurchaseStock',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      rawMaterialInfoList: null,
      stockTitle: null,
      meterialTypeLookup: null,
      companyInfoLookup: null,
      unitLookup: null
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxColumnFixing,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxLookup
  },
  computed: {
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.companyInfoLookup = this.$store.getters.getPartnersInfo
    this.unitLookup = this.$store.getters.getBaseDataByType(ConstDef.단위)
    this.refreshCurrentStock()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    temp (row) {
      return row.외부창고 + row.사급출고수량
    },
    calcTotalOutsourceStcokAmount (row) {
      return row.외부창고 + row.사급출고수량 - row.입고수량
    },
    calculateStcokAmount (row) {
      return row.창고재고 + row.현재공
    },
    calcTotalStcokAmount (row) {
      return row.현재공
    },
    onCellPrepared (e) {
      if (e.rowType === 'data' && e.column.caption === '합계') { // 창고재고
        this.$Q(e.cellElement).css('color', 'blue')
      }
    },
    onToolbarPreparing (e) {
      const baseDate = `${AppLib.calcMonthFromToday(0).substring(0, 7)}-01`
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:blue;'><b>이월기준일: ${baseDate}</b></div>`
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '이월재고 초기화',
            icon: 'refresh',
            text: '이월재고 초기화',
            type: 'default',
            focusStateEnabled: true,
            onClick: (args) => {
              this.$snotify.confirm('모든 품목의 마이너스 이월재고를 초기화 합니다.', '', {
                timeout: 10000,
                showProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                buttons: [
                  { text: '초기화',
                    action: (toast) => {
                      this.$snotify.remove(toast.id)
                      this.$_sp.runUpdateProc('spUpdateInventoryReset', null)
                        .then(data => {
                          this.$snotify.info('초기화 되었습니다.')
                          this.refreshCurrentStock()
                        })
                        .catch(error => {
                          this.isLoading = false
                          if (error.response.status === ConstDef.GENERRAL_ERROR) {
                            this.$snotify.error(error.response.data.message)
                          } else {
                            this.$snotify.error(`에러코드 : ${error.response.status}`)
                          }
                        })
                    }
                  },
                  { text: '취소',
                    action: (toast) => { this.$snotify.remove(toast.id) }
                  }
                ]
              })
            }
          }
        }
      )
    },
    refreshCurrentStock () {
      this.stockTitle = `${AppLib.getToday()}_구매품_재고`
      const param = {
        품목유형: ConstDef.구매품,
        자재유형: ConstDef.외주품
      }
      this.isLoading = true
      // this.$_sp.runNoEncodeFindProc('spFindAllStockReceiptByToDateAndPtypeV2', param)
      this.$_sp.runNoEncodeFindProc('spFindAllThisMonthPurchaseStock', param)
        .then((data) => {
          this.isLoading = false
          this.rawMaterialInfoList = this.$_sp.MakeModel(data)
          console.log(this.rawMaterialInfoList)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
